<div>
    <h1>Bem-Vindo(a) ao Portal FSB, {{fornecedor}} !</h1>
</div>
<div class="Aligner">
    <img src="../../../assets/img/logo-fsb-positivo.svg" width="380" alt="">
</div>


<po-modal #mensagemProcesso p-title="Atenção">
    <div>
        <h3>Prezados,</h3>
        <h3>Visando a melhoria do processo, fizemos alguns ajustes para que o portal fique mais intuitivo para upload de
            notas, atenção aos tópicos:</h3>

        <ng-container *ngIf="!isNivelQuatro">
            <h3><strong>Prazo entrada de notas</strong> - após o dia 10 o portal ficará bloqueado para novas inclusões,
                podendo ser acessado somente para consulta de pagamentos</h3>

            <h3><strong>Anexo PDF</strong> - agora o anexo será em sequência a inclusão de sua NF e PC, favor se atentar
                ao upload correto para que não perca a data do pagamento</h3>

            <h3><strong>Pagamento</strong> – o pagamento de sua nota no dia 25 do mesmo mês, fica condicionado ao upload
                correto de sua nota, seja numeração quanto ao anexo do seu PDF, lembrando que, o número da nota não é o
                mesmo do PC, mas sim a numeração de sua nota emitida</h3>
        </ng-container>

        <ng-container *ngIf="isNivelQuatro">
            <h3><strong>Prazo para entrada de notas</strong> - o prazo para entrada é de 01 a 10 e, após esse prazo o
                portal ficará bloqueado para novas inclusões, podendo ser acessado somente para consulta de pagamentos.
            </h3>

            <h3><strong>Anexo PDF</strong> - agora o anexo será em sequência a inclusão de sua NF e PC, favor atentar ao
                upload certo para que não perca a data de pagamento</h3>

            <h3><strong>Pagamento</strong> - o pagamento de sua nota ocorrerá dia 05 do mês seguinte, este fica
                condicionado ao upload correto no portal, seja referente a informações de numeração/série quanto ao
                anexo do PDF, lembrando que o número de sua nota não é o mesmo do PC, mas sim a numeração de sua nota
                emitida.</h3>
        </ng-container>
    </div>
</po-modal>

<po-modal #mensagemInclusao  p-title="Calendário de upload"  [p-primary-action]="modalAction">
    <div>
        <ng-container *ngIf="!isNivelQuatro">
            <h3>
                <strong>Upload de 1 a 5</strong> - recebe no dia 25 lembrando que se
                a nota for imputada com algum dado errado perde o benefício da
                antecipação e o pagamento será postergado para dia 05 do mês seguinte.
            </h3>

            <h3>
                <strong> Upload de 6 a 10</strong> - recebe no dia 05 do mês seguinte.
            </h3>
        </ng-container>

        <ng-container *ngIf="isNivelQuatro">
            <h3>
                <strong>Upload de 1 a 10</strong> - recebe no dia 05 do mês seguinte.
            </h3>
        </ng-container>
    </div>
</po-modal>

<po-modal #mensagemGov p-title="Atenção" [p-primary-action]="modalAction2">
    <div class="modal-alert">
        <span class="alert-triangle"></span>

        <h3>
            Informamos que, a partir de fevereiro/2026, haverá a mudança da série
            de RFB/UNI para GOV no portal de fornecedores.
        </h3>
       
    </div>
</po-modal>